import React from "react";
import { IconGridItem } from "@/shared/types/IconGrid.interface";

interface PreventiveGridProps {
    gridItems: IconGridItem[];
    wrapperClass?: string;
    testStyle?: boolean;
}

const PreventiveGridItem: React.FC<IconGridItem> = ({ icon, text, amount }) => (
    <li className="flex w-full items-center justify-between gap-1 text-xs text-content-secondary md:gap-1 lg:gap-2">
        <div className="flex w-full items-center gap-1 rounded text-center">
            <div className="justify-center">{icon}</div>
            {text && <span className="text-left font-medium leading-5">{text}</span>}
        </div>
        {amount && <span>${amount}</span>}
    </li>
);

export default function PreventiveGrid({ gridItems }: PreventiveGridProps) {
    if (!gridItems.length) return null;

    return (
        <div className="w-full">
            <ul className="mx-1 grid grid-cols-2 gap-1 md:gap-x-1 md:gap-y-2 lg:mx-0 lg:gap-x-3 lg:gap-y-2">
                {gridItems.map((item, index) => (
                    <PreventiveGridItem key={`icon-item-${index + 1}`} {...item} />
                ))}
            </ul>
        </div>
    );
}
